import { SalesOrderStatus } from "constants/types/salesOrder";

export const isDisableActions = (status: SalesOrderStatus): boolean => {
  switch (status) {
    case "pending":
      return false;
    case "confirmed":
      return true;
    default:
      return true;
  }
};
